<template>
    <v-flex md12 class="hero" v-if="this.$store.state.scrollDown"> 
        <a href="#" class="scroll-down" v-show="$vuetify.breakpoint.mdAndUp">  
          <div class="mouse">
            <span></span>
          </div>
          <!--<div class="mouse-img anim-zoom infinite">
              <img :src="require('../assets/presentacion/mouse.png')" alt="">
          </div>-->
          
            <div class="arrow">
                <span></span>
            </div>
        </a> 
      </v-flex>
</template>
<script>
export default {
    props:{
        vistodown:{
            type:Boolean,
            default:true
        }
    },
    data() {
        return {
        }
    },
    created() {
        // this.vistodown = this.$store.state.scrollEnd
    },
    methods: {
    },
    watch:{
        vistodown:function(val){
            this.vistodown = val
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../sass/globals';
.hero{
    width: 100%;
}
.scroll-down{
    position: absolute;
    bottom: 5rem; 
    //left:90vw;

    right: 40px;
    //transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    //right: 500px;
    //margin-left: 70%;
} 
.mouse{
    width: 2.5rem; 
    height: 5rem;
    //border: 2px solid #0d5abe;   
    background: linear-gradient(120deg, $color-secondary 0%, $color-complement-three 100%);
    border-radius: 2rem;
    margin-bottom: .5rem;
    display: flex; 
} 
.mouse span{
    width: 1rem;
    height: 1rem;
    background-color: #fff;
    display:block;
    border-radius: 50%;
    margin: auto;
    animation: move-wheel 1s alternate infinite;
}
.arrow span{
    display: block;
    width: 1rem;
    height: 1rem;
    border:3px solid transparent;
    border-right-color: $color-secondary;
    border-bottom-color: $color-complement-three;
    transform: rotate(45deg);
    animation: arrow-down 1s linear infinite;
}
@keyframes move-wheel{
    0%{
        opacity: 0;
        transform: translateY(-1rem);
    }
    100%{
        opacity: 1;
        transform: translateY(1rem);
    }
}
@keyframes arrow-down{
    0%{
        opacity: 0;
    }
    25%{
        opacity: .25;
    }
    50%{
        opacity: .5;
    }
    75%{
        opacity: .75;

    }
    100%{
        opacity: 1;
    }
}
.mouse-img{
    width: 80px;
}
</style>
